module.exports = __webpack_public_path__ + "img/my_page_brown.ee35082b.svg";